<template>
	<div class="valve-type">
		<h5 @click="onToggleGroup()" class="valve-type-heading">{{ valveGroupProp.name }}</h5>
		<div :class="{'hidden': valveGroupProp.handle != valveGroupOpenProp}" class="valve-sets">
			<div v-for="valveSet in viableValveSets" :key="valveSet.id" @click="onValveSetSelected(valveSet)" class="valve-set">
				<img :src="valveSet.thumbnail" :alt="valveSet.title" class="valve-set-img" :class="{'selected': valveSet == valveSetSelected}">
				<span class="valve-label">{{ valveSet.title }}</span>
			</div>
		</div>

		<div v-for="valveSet in viableValveSets"
			:id="'vs-' + valveSet.id" 
			:key="valveSet.id" 
			:class="{'hidden': valveSet != valveSetSelected || valveGroupProp.handle != valveGroupOpenProp}"
		>
			<h6 class="valve-set-finish-heading">Select Valve Finish</h6>
			<div class="valve-set-finishes">
				<div v-for="finish in valveSet.finishes.slice(0,5)" 
					:key="finish.id"
					:title="finish.title"
					class="valve-set-finish"
				>
					<img @click="onValveSelected(finish)" :src="finish.thumbnail" :alt="finish.title" :class="{'selected': finish == valveSelectedProp}" class="valve-set-finish-img">
					<span class="valve-label">{{ finish.finish }}</span>
				</div>

				<div v-for="finish in valveFinishBatchB"
					:key="finish.id"
					:title="finish.title"
					class="valve-set-finish valve-set-finish--hidden"
					data-finish-show-more
				>
					<img @click="onValveSelected(finish)" :src="finish.thumbnail" :alt="finish.title" :class="{'selected': finish == valveSelectedProp}" class="valve-set-finish-img">
					<span class="valve-label">{{ finish.finish }}</span>
				</div>
			</div>

			<button
				v-if="valveSet.finishes.length > 5"
				class="btn valve-set-finishes__more"
				@click="onFinishesShowMore(valveSet.id)"
			>
				Show more
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['suppHeaderSelectedProp', 'valveGroupProp', 'valveGroupOpenProp', 'valveSelectedProp'],
		data() {
			return {
				valveGroupOpen: null,
				valveSetSelected: null,
				valveSelected: null,
			};
		},
		methods: {
			onValveSelected: function(valve) {
				if (this.valveSelected == valve) {
					this.valveSelected = null;
					this.$emit('valveSelected', {
						id: 0,
						price: 0,
						pricePlusVat: 0,
						surcharge: 0,
						surchargePlusVat: 0,
						renderReference: '',
						thumbnail: '',
						title: ''
					});
				} else {
					this.valveSelected = valve;
					this.$emit('valveSelected', this.valveSelected);
				}
			},
			onValveSetSelected: function(valveSet) {
				this.valveSetSelected = valveSet;
				this.$emit('valveSetSelected', this.valveSelected);
			},
			onToggleGroup: function() {
				if (this.valveGroupProp.handle == this.valveGroupOpenProp) return;
				this.$emit('valveGroupOpen', this.valveGroupProp.handle);
				this.valveSetSelected = null;
			},
			onFinishesShowMore: function (id) {
				let els = document.getElementById(`vs-${id}`).querySelectorAll('[data-finish-show-more]')
				if (els) {
					Array.from(els, (el) => {
						el.classList.remove('valve-set-finish--hidden')
					})
				} else {
					return;
				}
				
			}
		},
		computed: {
			viableValveSets: function() {
				if (!this.suppHeaderSelectedProp) return this.valveGroupProp.valveSets;
				return this.valveGroupProp.valveSets.filter(valveSet => valveSet.duelFuel == true);
			},
			valveFinishBatchB: function () {
				if (!this.valveSetSelected || this.valveSetSelected.finishes.length < 5) return [];

				return this.valveSetSelected.finishes.slice(5);
			}
		}
	};
</script>

<style scoped>
	.valve-type {
		padding: 13px 9px;
		margin: 0 0 9px;
		background-color: #eee;
	}

	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}

	.valve-set-finish-heading {
		text-transform: uppercase;
		font-size: 10px;
	}

	.valve-type {
		padding: 13px 9px;
		margin: 0 0 9px;
		background-color: #eee;
	}

	.valve-type-heading {
		cursor: pointer;
		font-size: 12px;
		margin: 0;
	}

	.options {
		color: #333;
		font: 14px/1.5 "Lora",serif;
		margin: 9px 0 0;
	}

	.title {
		color: #333;
		font-size: 14px;
		line-height: 1.5;
		font-family: Arial, serif;
	}

	.valve-sets,
	.valve-set-finishes {
		display: flex;
		flex-wrap: wrap;
		margin: 9px 0 0;
	}

	.valve-set,
	.valve-set-finish {
		/* width: 59px; */
		width: calc(33% - 18px);
		margin: 0 18px 9px 0;
		display: flex;
		gap: 5px;
		align-content: center;
	}

	.valve-set-finish--hidden {
		display: none;
	}

	.valve-set-img,
	.valve-set-finish-img {
		box-sizing: border-box;
		border: 1px solid #eee;
		opacity: 0.5;
		cursor: pointer;
	}

	.valve-set-img:hover,
	.valve-set-finish-img:hover {
		border: 1px solid #2b2012;
	}

	.valve-set-img.selected,
	.valve-set-finish-img.selected {
		opacity: 1;
		border: 1px solid #a8d5e9;
	}

	.valve-finish {
		border: 1px solid #d6d6d6;
		cursor: pointer;
		opacity: 0.5;
	}

	.valve-finish.selected {
		opacity: 1;
		border: 1px solid #a8d5e9;
	}

	.valve-label {
		font-size: 10px;
		align-self: center;
	}

	.hidden {
		display: none;
	}

	@media screen and (min-width: 730px) {
		.valve-set,
		.valve-set-finish {
			width: calc(20% - 18px);
		}
	}
</style>